import { Snowflake } from "lucide-react";
import { useLang } from "@/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-sky-500/10 bg-[#070C16] py-6"
      aria-hidden="true"
    >
      <div className="marquee-track items-center">
        {[...items, ...items].map((item, i) => (
          <span
            key={i}
            className="mx-8 flex items-center gap-8 whitespace-nowrap text-sm font-semibold uppercase tracking-[0.3em] text-slate-500"
          >
            {item}
            <Snowflake size={14} className="text-sky-500/50" />
          </span>
        ))}
      </div>
    </div>
  );
};
